//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.19.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpBackend, HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';
import { SettingsService } from './settings.service';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export interface IClient {
    /**
     * @param auth (optional) 
     * @param locationId (optional) 
     * @param body (optional) 
     * @return No Content
     */
    consentDetails(auth: string | undefined, companyId: string | undefined, orderId: string | undefined, locationId: string | undefined, body: EndApproval[] | undefined): Observable<any>;
    
     /**
     * @param auth (optional) 
     * @param locationId (optional) 
     * @param body (optional) 
     * @return No Content
     */
     authorizeSchedulingJob(auth: string | undefined, companyId: string | undefined, schedulingorderId: string | undefined, locationId: string | undefined, body: EndApproval[] | undefined): Observable<any>;
    /**
     * @param token (optional) 
     * @return Success
     */
    pageLoadDetails(token: string | undefined): Observable<GetDetailsResponse>;
    
    /**
     * @param token (optional) 
     * @return Success
     */
    ServiceOrderDetails(token: string | undefined): Observable<any>

    /**
     * @param locationId (optional) 
     * @return Success
     */
    getChecklistDetails(token: string | undefined, publishToCustomerOnly: boolean | undefined, accept_Language: string | undefined): Observable<ChecklistDetailsResponse>;

    /**
     * @param token (optional) 
     * @return Success
     */
    getStyleSettings(token: string | undefined, accept_Language: string | undefined): Observable<StyleSettingsResponse>;

    /**
     * @param token (optional) 
     * @return Success
     */
    getChecklistReport(token: string | undefined, accept_Language: string | undefined): Observable<string>

    /**
     * @param token (optional) 
     * @param publishToCustomerOnly (optional) 
     * @param accept_Language (optional) 
     * @return Success
     */
    healthCheckReport(token: string | undefined, publishToCustomerOnly: boolean | undefined, accept_Language: string | undefined): Observable<VehicleHealthChecklestResponse>

    /**
     * @param auth (optional) 
     * @param locationId (optional) 
     * @param accept_Language (optional) 
     * @param body (optional) 
     * @return No Content
     */
    getDealerMedia(token: string | undefined, accept_Language: string | undefined): Observable<DealerMediaResponse>;

    /**
     * @param token
     * @return Success
     */
    proformaDetails(token: string | undefined, accept_Language: string | undefined): Observable<ProformaDetails[]>;
    /**
     * @param auth (optional) 
     * @param body (optional) 
     * @return No Content
     */
    proformaConsentDetails(token: string | undefined, accept_Language: string | undefined, body: Approvalstatus[] | undefined): Observable<any>;
    /**
     * @param token (optional) 
     * @return Success
     */
    proformaReport(token: string | undefined, accept_Language: string | undefined): Observable<string>

    /**
     * @param token (optional) 
     * @return Success
     */
    getFeatures(token: string | undefined): Observable<FeatureFlag[]>;
}

@Injectable({
    providedIn: 'root'
})
export class Client implements IClient {
    private http: HttpClient;
    private baseUrl: string | undefined;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(private settings: SettingsService, private httpBackend: HttpBackend, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string | undefined) {
        this.http = http;
        this.baseUrl = baseUrl;

    }

    /**
     * @param auth (optional) 
     * @param locationId (optional) 
     * @param body (optional) 
     * @return No Content
     */
    consentDetails(auth: string | undefined, companyId: string | undefined, orderId: string | undefined, locationId: string | undefined, body: EndApproval[] | undefined): Observable<any> {
        let url_ = this.baseUrl + "/api/ConsentDetails/{companyId}/{orderId}/approve?";
        if (companyId === undefined || companyId === null)
            throw new Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "auth": auth !== undefined && auth !== null ? "" + auth : "",
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processConsentDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConsentDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processConsentDetails(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = DmsProblemDetails.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result401: any = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = DmsProblemDetails.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = DmsProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result500: any = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = DmsProblemDetails.fromJS(resultData500);
                return throwException("Forbidden", status, _responseText, _headers, resultData500);
            }));
        } else if (status === 503) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result503: any = null;
                let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result503 = DmsProblemDetails.fromJS(resultData503);
                return _observableOf(result503);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<any>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(response);
    }


    authorizeSchedulingJob(auth: string | undefined, companyId: string | undefined, schedulingorderId: string | undefined, locationId: string | undefined, body: EndApproval[] | undefined): Observable<any> {
        let url_ = this.baseUrl + "/api/SchedulingOrder/{companyId}/{schedulingorderId}/approve?";
        if (companyId === undefined || companyId === null)
            throw new Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        if (schedulingorderId === undefined || schedulingorderId === null)
            throw new Error("The parameter 'schedulingorderId' must be defined.");
        url_ = url_.replace("{schedulingorderId}", encodeURIComponent("" + schedulingorderId));
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "auth": auth !== undefined && auth !== null ? "" + auth : "",
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.authorizeprocessConsentDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.authorizeprocessConsentDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected authorizeprocessConsentDetails(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = DmsProblemDetails.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result401: any = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = DmsProblemDetails.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = DmsProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result500: any = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = DmsProblemDetails.fromJS(resultData500);
                return throwException("Forbidden", status, _responseText, _headers, resultData500);
            }));
        } else if (status === 503) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result503: any = null;
                let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result503 = DmsProblemDetails.fromJS(resultData503);
                return _observableOf(result503);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<any>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(response);
    }


    authorizeSevicequoteconsentdetails(auth: string | undefined, companyId: string | undefined, quoteId: string | undefined, locationId: string | undefined, body: EndApproval[] | undefined): Observable<any> {
        let url_ = this.baseUrl + "/api/ServiceQuote/{companyId}/{quoteId}/approve?";
        if (companyId === undefined || companyId === null)
            throw new Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        if (quoteId === undefined || quoteId === null)
            throw new Error("The parameter 'quoteId' must be defined.");
        url_ = url_.replace("{quoteId}", encodeURIComponent("" + quoteId));
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "auth": auth !== undefined && auth !== null ? "" + auth : "",
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.authorizeQuoteprocessConsentDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.authorizeQuoteprocessConsentDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected authorizeQuoteprocessConsentDetails(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = DmsProblemDetails.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result401: any = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = DmsProblemDetails.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = DmsProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result500: any = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = DmsProblemDetails.fromJS(resultData500);
                return throwException("Forbidden", status, _responseText, _headers, resultData500);
            }));
        } else if (status === 503) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result503: any = null;
                let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result503 = DmsProblemDetails.fromJS(resultData503);
                return _observableOf(result503);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<any>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(response);
    }
    /**
     * @param token (optional) 
     * @return Success
     */
    ServiceOrderDetails(token: string | undefined): Observable<any> {
        //this.baseUrl= "https://localhost:44320"
        let url_ = this.baseUrl + "/api/Details/ServiceOrderDetails";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "token": token !== undefined && token !== null ? "" + token : "",
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processServiceOrderDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceOrderDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processServiceOrderDetails(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = DmsProblemDetails.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result401: any = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = DmsProblemDetails.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = DmsProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result500: any = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = DmsProblemDetails.fromJS(resultData500);
                return throwException("Forbidden", status, _responseText, _headers, resultData500);
            }));
        } else if (status === 503) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result503: any = null;
                let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result503 = DmsProblemDetails.fromJS(resultData503);
                return _observableOf(result503);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = _responseText ? JSON.parse(_responseText, this.jsonParseReviver) : null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(null as any);
    }

        /**
     * @param token (optional) 
     * @return Success
     */
    pageLoadDetails(token: string | undefined): Observable<GetDetailsResponse> {
        let url_ = this.baseUrl + "/api/Details";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "token": token !== undefined && token !== null ? "" + token : "",
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processPageLoadDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPageLoadDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDetailsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDetailsResponse>;
        }));
    }

    protected processPageLoadDetails(response: HttpResponseBase): Observable<GetDetailsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = DmsProblemDetails.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result401: any = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = DmsProblemDetails.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = DmsProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result500: any = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = DmsProblemDetails.fromJS(resultData500);
                return throwException("Forbidden", status, _responseText, _headers, resultData500);
            }));
        } else if (status === 503) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result503: any = null;
                let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result503 = DmsProblemDetails.fromJS(resultData503);
                return _observableOf(result503);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetDetailsResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDetailsResponse>(null as any);
    }

    pageLoadSchedulingDetails(token: string | undefined): Observable<any> {
        let url_ = this.baseUrl + "/api/SchedulingOrder";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "token": token !== undefined && token !== null ? "" + token : "",
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processPageLoadSchedulingDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPageLoadSchedulingDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processPageLoadSchedulingDetails(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = DmsProblemDetails.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result401: any = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = DmsProblemDetails.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = DmsProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result500: any = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = DmsProblemDetails.fromJS(resultData500);
                return throwException("Forbidden", status, _responseText, _headers, resultData500);
            }));
        } else if (status === 503) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result503: any = null;
                let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result503 = DmsProblemDetails.fromJS(resultData503);
                return _observableOf(result503);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = _responseText ? JSON.parse(_responseText, this.jsonParseReviver) : null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(null as any);
    }


    pageLoadQuoteDetails(token: string | undefined): Observable<any> {
        let url_ = this.baseUrl + "/api/ServiceQuote";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "token": token !== undefined && token !== null ? "" + token : "",
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processPageLoadQuoteDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPageLoadQuoteDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processPageLoadQuoteDetails(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = DmsProblemDetails.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result401: any = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = DmsProblemDetails.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = DmsProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result500: any = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = DmsProblemDetails.fromJS(resultData500);
                return throwException("Forbidden", status, _responseText, _headers, resultData500);
            }));
        } else if (status === 503) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result503: any = null;
                let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result503 = DmsProblemDetails.fromJS(resultData503);
                return _observableOf(result503);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = _responseText ? JSON.parse(_responseText, this.jsonParseReviver) : null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(null as any);
    }

    getChecklistDetails(token: string | undefined, publishToCustomerOnly: boolean | undefined, accept_Language: string | undefined): Observable<ChecklistDetailsResponse> {
        let url_ = this.baseUrl + "/api/Details/companies/checklistsId/checklistId?";
        if (publishToCustomerOnly === null)
            throw new Error("The parameter 'publishToCustomerOnly' cannot be null.");
        else if (publishToCustomerOnly !== undefined)
            url_ += "publishToCustomerOnly=" + encodeURIComponent("" + publishToCustomerOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "token": token !== undefined && token !== null ? "" + token : "",
                "Accept-Language": accept_Language !== undefined && accept_Language !== null ? "" + accept_Language : "",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetChecklistDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChecklistDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChecklistDetailsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChecklistDetailsResponse>;
        }));
    }

    protected processGetChecklistDetails(response: HttpResponseBase): Observable<ChecklistDetailsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ChecklistDetailsResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = DmsProblemDetails.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result401: any = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = DmsProblemDetails.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = DmsProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result500: any = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = DmsProblemDetails.fromJS(resultData500);
                return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 503) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result503: any = null;
                let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result503 = DmsProblemDetails.fromJS(resultData503);
                return throwException("Server Error", status, _responseText, _headers, result503);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ChecklistDetailsResponse>(null as any);
    }

    getStyleSettings(token: string | undefined, accept_Language: string | undefined): Observable<StyleSettingsResponse> {
        let url_ = this.baseUrl + "/api/StyleSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "token": token !== undefined && token !== null ? "" + token : "",
                "Accept-Language": accept_Language !== undefined && accept_Language !== null ? "" + accept_Language : "",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetStyleSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStyleSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StyleSettingsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StyleSettingsResponse>;
        }));
    }

    protected processGetStyleSettings(response: HttpResponseBase): Observable<StyleSettingsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = DmsProblemDetails.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result401: any = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = DmsProblemDetails.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = DmsProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result500: any = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = DmsProblemDetails.fromJS(resultData500);
                return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 503) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result503: any = null;
                let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result503 = DmsProblemDetails.fromJS(resultData503);
                return throwException("Server Error", status, _responseText, _headers, result503);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = StyleSettingsResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }


    getChecklistReport(token: string | undefined, accept_Language: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/ChecklistReport";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "token": token !== undefined && token !== null ? "" + token : "",
                "Accept-Language": accept_Language !== undefined && accept_Language !== null ? "" + accept_Language : "",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetChecklistReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChecklistReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetChecklistReport(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = DmsProblemDetails.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result401: any = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = DmsProblemDetails.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = DmsProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result500: any = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = DmsProblemDetails.fromJS(resultData500);
                return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 503) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result503: any = null;
                let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result503 = DmsProblemDetails.fromJS(resultData503);
                return throwException("Server Error", status, _responseText, _headers, result503);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : (_responseText);
                result200 = resultData200;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getServiceOrderReport(token: string | undefined, accept_Language: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Details/ServiceOrderReport";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "token": token !== undefined && token !== null ? "" + token : "",
                "Accept-Language": accept_Language !== undefined && accept_Language !== null ? "" + accept_Language : "",
            })
        };

        return this.http.request("Get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetServiceOrderReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServiceOrderReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetServiceOrderReport(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = DmsProblemDetails.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result401: any = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = DmsProblemDetails.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = DmsProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result500: any = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = DmsProblemDetails.fromJS(resultData500);
                return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 503) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result503: any = null;
                let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result503 = DmsProblemDetails.fromJS(resultData503);
                return throwException("Server Error", status, _responseText, _headers, result503);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : (_responseText);
                result200 = resultData200;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSchedulingOrderPDFReport(token: string | undefined, accept_Language: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/SchedulingOrder/SchedulingReport";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "token": token !== undefined && token !== null ? "" + token : "",
                "Accept-Language": accept_Language !== undefined && accept_Language !== null ? "" + accept_Language : "",
            })
        };

        return this.http.request("Get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAppointmentsReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAppointmentsReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetAppointmentsReport(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = DmsProblemDetails.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result401: any = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = DmsProblemDetails.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = DmsProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result500: any = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = DmsProblemDetails.fromJS(resultData500);
                return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 503) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result503: any = null;
                let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result503 = DmsProblemDetails.fromJS(resultData503);
                return throwException("Server Error", status, _responseText, _headers, result503);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : (_responseText);
                result200 = resultData200;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getQuoteReport(token: string | undefined, accept_Language: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/ServiceQuote/QuoteReport";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "token": token !== undefined && token !== null ? "" + token : "",
                "Accept-Language": accept_Language !== undefined && accept_Language !== null ? "" + accept_Language : "",
            })
        };

        return this.http.request("Get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetQuoteReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQuoteReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetQuoteReport(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = DmsProblemDetails.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result401: any = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = DmsProblemDetails.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = DmsProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result500: any = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = DmsProblemDetails.fromJS(resultData500);
                return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 503) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result503: any = null;
                let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result503 = DmsProblemDetails.fromJS(resultData503);
                return throwException("Server Error", status, _responseText, _headers, result503);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : (_responseText);
                result200 = resultData200;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param token (optional) 
     * @param publishToCustomerOnly (optional) 
     * @param accept_Language (optional) 
     * @return Success
     */
    healthCheckReport(token: string | undefined, publishToCustomerOnly: boolean | undefined, accept_Language: string | undefined): Observable<VehicleHealthChecklestResponse> {
        let url_ = this.baseUrl + "/api/Details/HealthCheckReport?";
        if (publishToCustomerOnly === null)
            throw new Error("The parameter 'publishToCustomerOnly' cannot be null.");
        else if (publishToCustomerOnly !== undefined)
            url_ += "publishToCustomerOnly=" + encodeURIComponent("" + publishToCustomerOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "token": token !== undefined && token !== null ? "" + token : "",
                "Accept-Language": accept_Language !== undefined && accept_Language !== null ? "" + accept_Language : "",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHealthCheckReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHealthCheckReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VehicleHealthChecklestResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VehicleHealthChecklestResponse>;
        }));
    }

    protected processHealthCheckReport(response: HttpResponseBase): Observable<VehicleHealthChecklestResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = DmsProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = DmsProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = DmsProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = DmsProblemDetails.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 503) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = DmsProblemDetails.fromJS(resultData503);
            return throwException("Server Error", status, _responseText, _headers, result503);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = VehicleHealthChecklestResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
 * @param token (optional) 
 * @param publishToCustomerOnly (optional) 
 * @param accept_Language (optional) 
 * @return Success
 */
healthCheckReportWithJobs(token: string | undefined, publishToCustomerOnly: boolean | undefined, accept_Language: string | undefined): Observable<any> {
    let url_ = this.baseUrl + "/api/Details/HealthCheckReportWithJobs?";

    if (publishToCustomerOnly === null)
        throw new Error("The parameter 'publishToCustomerOnly' cannot be null.");
    else if (publishToCustomerOnly !== undefined)
        url_ += "publishToCustomerOnly=" + encodeURIComponent("" + publishToCustomerOnly) + "&";
    
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
        observe: "response",
        responseType: "blob",
        headers: new HttpHeaders({
            "token": token !== undefined && token !== null ? "" + token : "",
            "Accept-Language": accept_Language !== undefined && accept_Language !== null ? "" + accept_Language : "",
        })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
        return this.processHealthCheckReportWithJobs(response_);
    })).pipe(_observableCatch((response_: any) => {
        if (response_ instanceof HttpResponseBase) {
            try {
                return this.processHealthCheckReportWithJobs(response_ as any);
            } catch (e) {
                return _observableThrow(e) as any as Observable<any>;
            }
        } else
            return _observableThrow(response_) as any as Observable<any>;
    }));
}

protected processHealthCheckReportWithJobs(response: HttpResponseBase): Observable<any> {
    const status = response.status;
    const responseBlob =
        response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; 
    if (response.headers) { 
        for (let key of response.headers.keys()) { 
            _headers[key] = response.headers.get(key); 
        }
    }

    if (status === 400) {
        return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = _responseText ? JSON.parse(_responseText, this.jsonParseReviver) : null;
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }));
    } else if (status === 401) {
        return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = _responseText ? JSON.parse(_responseText, this.jsonParseReviver) : null;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
        }));
    } else if (status === 403) {
        return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = _responseText ? JSON.parse(_responseText, this.jsonParseReviver) : null;
            return throwException("Forbidden", status, _responseText, _headers, result403);
        }));
    } else if (status === 500 || status === 503) {
        return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = _responseText ? JSON.parse(_responseText, this.jsonParseReviver) : null;
            return throwException("Server Error", status, _responseText, _headers, result500);
        }));
    } else if (status === 200) {
        return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = _responseText ? JSON.parse(_responseText, this.jsonParseReviver) : null;
            return _observableOf(result200);
        }));
    } else {
        return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }));
    }
}


    getDealerMedia(token: string | undefined, accept_Language: string | undefined): Observable<DealerMediaResponse> {
        let url_ = this.baseUrl + "/api/ChecklistReport/dealer/media";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "token": token !== undefined && token !== null ? "" + token : "",
                "Accept-Language": accept_Language !== undefined && accept_Language !== null ? "" + accept_Language : "",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDealerMedia(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDealerMedia(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DealerMediaResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DealerMediaResponse>;
        }));
    }

    protected processGetDealerMedia(response: HttpResponseBase): Observable<DealerMediaResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DmsProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DmsProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DmsProblemDetails;
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DmsProblemDetails;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 503) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result503: any = null;
            result503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DmsProblemDetails;
            return throwException("Service Unavailable", status, _responseText, _headers, result503);
            }));
	    } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DealerMediaResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLongUrl(shortUrlRequest: ShortUrlRequest): Observable<LongUrlResponse> {
        let url_ = this.baseUrl + "/api/Files";
        url_ = url_.replace(/[?&]$/, ""); 
    
        const content_ = JSON.stringify(shortUrlRequest);
    
        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "json", 
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            }),
        };
    
        return this.http.request("post", url_, options_).pipe(
            _observableMergeMap((response_: any) => {
                return this.processGetLongUrl(response_);
            }),
            _observableCatch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processGetLongUrl(response_ as any);
                    } catch (e) {
                        return _observableThrow(e) as any as Observable<LongUrlResponse>;
                    }
                } else {
                    return _observableThrow(response_) as any as Observable<LongUrlResponse>;
                }
            })
        );
    }
    
    protected processGetLongUrl(response: HttpResponseBase): Observable<LongUrlResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;
    
        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
    
        if (status === 200) {
            if (responseBlob instanceof Blob) {
                return blobToText(responseBlob).pipe(
                    _observableMergeMap((_responseText: string) => {
                        let result200: any = null;
                        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                        result200 = LongUrlResponse.fromJS(resultData200);
                        return _observableOf(result200);
                    })
                );
            } else {
                const result200 = LongUrlResponse.fromJS(responseBlob);
                return _observableOf(result200);
            }
        } else if (status === 400 || status === 401 || status === 403 || status === 500 || status === 503) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText: string) => {
                    let resultError: any = null;
                    resultError = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DmsProblemDetails;
                    return throwException("Error response from server", status, _responseText, _headers, resultError);
                })
            );
        } else {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText: string) => {
                    return throwException("An unexpected server error occurred.", status, _responseText, _headers);
                })
            );
        }
    }
    
    

    proformaDetails(token: string | undefined, accept_Language: string | undefined): Observable<ProformaDetails[]> {
        let url_ = this.baseUrl + "/api/proformainvoices/details";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "token": token !== undefined && token !== null ? "" + token : "",
                "Accept-Language": accept_Language !== undefined && accept_Language !== null ? "" + accept_Language : "",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProformaDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProformaDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProformaDetails[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProformaDetails[]>;
        }));
    }

    protected processProformaDetails(response: HttpResponseBase): Observable<ProformaDetails[]> {
        const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 400) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = DmsProblemDetails.fromJS(result400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result401: any = null;
        let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = DmsProblemDetails.fromJS(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);
      }));
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result403: any = null;
        let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result403 = DmsProblemDetails.fromJS(resultData403);
        return throwException("Forbidden", status, _responseText, _headers, result403);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("Server Error", status, _responseText, _headers);
      }));
    } else if (status === 503) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result503: any = null;
        let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result503 = DmsProblemDetails.fromJS(resultData503);
        return throwException("Server Error", status, _responseText, _headers, result503);
      }));
    } else if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(ProformaDetails.fromJS(item));
        }
        else {
          result200 = <any>null;
        }
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf(null as any);
    }

    proformaConsentDetails(token: string | undefined, accept_Language: string | undefined,  body: Approvalstatus[] | undefined): Observable<any> {
        let url_ = this.baseUrl + "/api/proformainvoices/approve";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "token": token !== undefined && token !== null ? "" + token : "",
                "Accept-Language": accept_Language !== undefined && accept_Language !== null ? "" + accept_Language : "",
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processProformaConsentDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProformaConsentDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processProformaConsentDetails(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = DmsProblemDetails.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result401: any = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = DmsProblemDetails.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = DmsProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result500: any = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = DmsProblemDetails.fromJS(resultData500);
                return throwException("Forbidden", status, _responseText, _headers, resultData500);
            }));
        } else if (status === 503) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result503: any = null;
                let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result503 = DmsProblemDetails.fromJS(resultData503);
                return _observableOf(result503);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<any>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(response);
    }

    proformaReport(token: string | undefined, accept_Language: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/proformainvoices/documents";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "token": token !== undefined && token !== null ? "" + token : "",
                "Accept-Language": accept_Language !== undefined && accept_Language !== null ? "" + accept_Language : "",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProformaReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProformaReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processProformaReport(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = DmsProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = DmsProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = DmsProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = DmsProblemDetails.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 503) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = DmsProblemDetails.fromJS(resultData503);
            return throwException("Server Error", status, _responseText, _headers, result503);
            }));
        }  else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : (_responseText);
                result200 = resultData200;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param token (optional) 
     * @return Success
     */
    getFeatures(token: string | undefined): Observable<FeatureFlag[]> {
        let url_ = this.baseUrl + "/api/Details/GetFeatures";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "token": token !== undefined && token !== null ? "" + token : "",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFeatures(response_);
        })).pipe(_observableCatch((response_: any) => {            
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFeatures(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FeatureFlag[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FeatureFlag[]>;
        }));
    }

    protected processGetFeatures(response: HttpResponseBase): Observable<FeatureFlag[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        const apiAdapterVersion = response.headers.get('ApiAdapterVersion');
        if (apiAdapterVersion) {
            sessionStorage.setItem('apiAdapterVersion', apiAdapterVersion);
        }
        
        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = DmsProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = DmsProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = DmsProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = DmsProblemDetails.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 503) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = DmsProblemDetails.fromJS(resultData503);
            return throwException("Server Error", status, _responseText, _headers, result503);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                  result200 = [] as any;
                  for (let item of resultData200)
                    result200!.push(FeatureFlag.fromJS(item));
                }
                else {
                  result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class VehicleHealthChecklestResponse implements IVehicleHealthChecklestResponse {
    id?: string | undefined;
    name?: string | undefined;
    status?: string | undefined;
    submittedDate?: string | undefined;
    categoriesOk?: MapedChecklistDetailsOrder | undefined;
    attentionRequired?: MapedChecklistDetailsOrder | undefined;
    urgentRequired?: MapedChecklistDetailsOrder | undefined;
    order?: ChecklistDetailsOrder | undefined;


    constructor(data?: IVehicleHealthChecklestResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.status = _data["status"];
            this.submittedDate = _data["submittedDate"];
            this.categoriesOk = _data["categoriesOk"] ? MapedChecklistDetailsOrder.fromJS(_data["categoriesOk"]) : <any>undefined;
            this.attentionRequired = _data["attentionRequired"] ? MapedChecklistDetailsOrder.fromJS(_data["attentionRequired"]) : <any>undefined;
            this.urgentRequired = _data["urgentRequired"] ? MapedChecklistDetailsOrder.fromJS(_data["urgentRequired"]) : <any>undefined;
            this.order = _data["order"] ? ChecklistDetailsOrder.fromJS(_data["order"]) : <any>undefined;
            
        }
    }

    static fromJS(data: any): VehicleHealthChecklestResponse {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleHealthChecklestResponse(data);
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["status"] = this.status;
        data["submittedDate"] = this.submittedDate;
        data["categoriesOk"] = this.categoriesOk ? this.categoriesOk.toJSON() : <any>undefined;
        data["attentionRequired"] = this.attentionRequired ? this.attentionRequired.toJSON() : <any>undefined;
        data["urgentRequired"] = this.urgentRequired ? this.urgentRequired.toJSON() : <any>undefined;
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;

        return data;
    }
}

export interface IVehicleHealthChecklestResponse {
    id?: string | undefined;
    name?: string | undefined;
    status?: string | undefined;
    submittedDate?: string | undefined;
    categoriesOk?: MapedChecklistDetailsOrder | undefined;
    attentionRequired?: MapedChecklistDetailsOrder | undefined;
    urgentRequired?: MapedChecklistDetailsOrder | undefined;
    order?: ChecklistDetailsOrder | undefined;
}

export class MapedChecklistDetailsOrder implements IMapedChecklistDetailsOrder {
    count?: number | undefined;
    categories?: ChecklistDetailsCategories[] | undefined;

    constructor(data?: IMapedChecklistDetailsOrder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let categories of _data["categories"])
                    this.categories!.push(ChecklistDetailsCategories.fromJS(categories));
            }
        }
    }

    static fromJS(data: any): MapedChecklistDetailsOrder {
        data = typeof data === 'object' ? data : {};
        let result = new MapedChecklistDetailsOrder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let categories of this.categories)
                data["categories"].push(categories.toJSON());
        }

        return data;
    }
}

export interface IMapedChecklistDetailsOrder {
    count?: number | undefined;
    categories?: ChecklistDetailsCategories[] | undefined;
}


export class StyleSettingsResponse implements IStyleSettingsResponse {
    dealerImage?: StyleSettingsDealerImage | undefined;
    dealerLogo?: StyleSettingsDealerLogo | undefined;
    style: StyleSettingsStyle | undefined;
    titles: StyleSettingTitles[] | undefined;

    constructor(data?: IStyleSettingsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dealerImage = _data["dealerImage"];
            this.dealerLogo = _data["dealerLogo"];
            this.style = _data["style"];
            if (Array.isArray(_data["titles"])) {
                this.titles = [] as any;
                for (let item of _data["titles"])
                    this.titles!.push(StyleSettingTitles.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StyleSettingsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new StyleSettingsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data["dealerImage"] = this.dealerImage ? this.dealerImage.toJSON() : <any>undefined;
        data["dealerLogo"] = this.dealerLogo ? this.dealerLogo.toJSON() : <any>undefined;
        data["style"] = this.style ? this.style.toJSON() : <any>undefined;
        if (Array.isArray(this.titles)) {
            data["titles"] = [];
            for (let item of this.titles)
                data["titles"].push(item.toJSON());
        }

        return data;
    }
}

export interface IStyleSettingsResponse {
    dealerImage?: StyleSettingsDealerImage | undefined;
    dealerLogo?: StyleSettingsDealerLogo | undefined;
    style: StyleSettingsStyle | undefined;
    titles: StyleSettingTitles[] | undefined;
}


export class StyleSettingsDealerImage implements IStyleSettingsDealerImage {
    id?: string | undefined;
    mimeType?: string | undefined;
    storage?: string | undefined;
    externalId?: string | undefined;
    url?: string | undefined;

    constructor(data?: IStyleSettingsDealerImage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.mimeType = _data["mimeType"];
            this.storage = _data["storage"];
            this.externalId = _data["externalId"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): StyleSettingsDealerImage {
        data = typeof data === 'object' ? data : {};
        let result = new StyleSettingsDealerImage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["mimeType"] = this.mimeType;
        data["storage"] = this.storage;
        data["externalId"] = this.externalId;
        data["url"] = this.url;

        return data;
    }
}

export interface IStyleSettingsDealerImage {
    id?: string | undefined;
    mimeType?: string | undefined;
    storage?: string | undefined;
    externalId?: string | undefined;
    url?: string | undefined;
}

export class StyleSettingsDealerLogo implements IStyleSettingsDealerLogo {
    id?: string | undefined;
    mimeType?: string | undefined;
    storage?: string | undefined;
    externalId?: string | undefined;
    url?: string | undefined;

    constructor(data?: IStyleSettingsDealerLogo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.mimeType = _data["mimeType"];
            this.storage = _data["storage"];
            this.externalId = _data["externalId"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): StyleSettingsDealerLogo {
        data = typeof data === 'object' ? data : {};
        let result = new StyleSettingsDealerLogo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["mimeType"] = this.mimeType;
        data["storage"] = this.storage;
        data["externalId"] = this.externalId;
        data["url"] = this.url;

        return data;
    }
}

export interface IStyleSettingsDealerLogo {
    id?: string | undefined;
    mimeType?: string | undefined;
    storage?: string | undefined;
    externalId?: string | undefined;
    url?: string | undefined;
}

export class StyleSettingTitles implements IStyleSettingTitles {
    type?: string | undefined;
    content?: string | undefined;
    page?: string | undefined;
    style?: ColorFontDetails | undefined;

    constructor(data?: IStyleSettingTitles) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.content = _data["content"];
            this.page = _data["page"];
            this.style = _data["style"];
        }
    }

    static fromJS(data: any): StyleSettingTitles {
        data = typeof data === 'object' ? data : {};
        let result = new StyleSettingTitles();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["content"] = this.content;
        data["page"] = this.page;
        data["style"] = this.style ? this.style.toJSON() : <any>undefined;

        return data;
    }
}

export interface IStyleSettingTitles {
    type?: string | undefined;
    content?: string | undefined;
    page?: string | undefined;
    style?: ColorFontDetails | undefined;
}

export class StyleSettingsStyle implements IStyleSettingsStyle {
    backgroundColor?: string | undefined;
    header: ColorFontDetails | undefined;
    infoBlock: ColorFontDetails | undefined;
    tile: ColorFontDetails | undefined;
    buttons: ButtonDetails[] | undefined;

    constructor(data?: IStyleSettingsStyle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.backgroundColor = _data["backgroundColor"];
            this.header = _data["header"];
            this.infoBlock = _data["infoBlock"];
            this.tile = _data["tile"];
        }
    }

    static fromJS(data: any): StyleSettingsStyle {
        data = typeof data === 'object' ? data : {};
        let result = new StyleSettingsStyle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["backgroundColor"] = this.backgroundColor;
        data["header"] = this.header ? this.header.toJSON() : <any>undefined;
        data["infoBlock"] = this.infoBlock ? this.infoBlock.toJSON() : <any>undefined;
        data["tile"] = this.tile ? this.tile.toJSON() : <any>undefined;

        return data;
    }
}

export interface IStyleSettingsStyle {
    backgroundColor?: string | undefined;
    header: ColorFontDetails | undefined;
    infoBlock: ColorFontDetails | undefined;
    tile: ColorFontDetails | undefined;
    buttons: ButtonDetails[] | undefined;
}

export class ColorFontDetails implements IColorFontDetails {
    backgroundColor?: string | undefined;
    fontColor?: string | undefined;
    font?: string | undefined;
    borderColor: string | undefined;
    borderRadius: string | undefined;
    borderWidth: string | undefined;

    constructor(data?: IColorFontDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.backgroundColor = _data["backgroundColor"];
            this.fontColor = _data["fontColor"];
            this.font = _data["font"];
            this.borderColor = _data["borderColor"];
            this.borderRadius = _data["borderRadius"];
            this.borderWidth = _data["borderWidth"];
        }
    }

    static fromJS(data: any): ColorFontDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ColorFontDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["backgroundColor"] = this.backgroundColor;
        data["fontColor"] = this.fontColor;
        data["font"] = this.font;
        data["borderColor"] = this.borderColor;
        data["borderRadius"] = this.borderRadius;
        data["borderWidth"] = this.borderWidth;

        return data;
    }
}

export interface IColorFontDetails {
    backgroundColor?: string | undefined;
    fontColor?: string | undefined;
    font?: string | undefined;
    borderColor: string | undefined;
    borderRadius: string | undefined;
    borderWidth: string | undefined;
}


export class ButtonDetails implements IButtonDetails {
    name?: string | undefined;
    style?: ColorFontDetails | undefined;
    hover?: ColorFontDetails | undefined;

    constructor(data?: IButtonDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.style = _data["style"];
            this.hover = _data["hover"];
        }
    }

    static fromJS(data: any): ButtonDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ButtonDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["style"] = this.style ? this.style.toJSON() : <any>undefined;
        data["hover"] = this.hover ? this.hover.toJSON() : <any>undefined;

        return data;
    }
}

export interface IButtonDetails {
    name?: string | undefined;
    style?: ColorFontDetails | undefined;
    hover?: ColorFontDetails | undefined;
}

export class Checkpoint implements ICheckpoint {
    id?: string | undefined;
    description?: string | undefined;
    image?: FileLink;
    status?: CheckpointStatus;
    isMandatory?: boolean | undefined;
    findingTypeOptions?: FindingTypeOption[] | undefined;
    findings?: Finding[] | undefined;
    measuredValues?: MeasuredValue[] | undefined;
    solution?: Solution;
    isManuallyCreated:  boolean | undefined;
    detailedDescription: string | undefined;
    comment: string | undefined;
    media: FileLinkWithThumbnail[] | undefined;
    isWalkthroughEnabled?: boolean | undefined;

    constructor(data?: ICheckpoint) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.image = _data["image"] ? FileLink.fromJS(_data["image"]) : <any>undefined;
            this.status = _data["status"];
            this.isMandatory = _data["isMandatory"];
            if (Array.isArray(_data["findingTypeOptions"])) {
                this.findingTypeOptions = [] as any;
                for (let item of _data["findingTypeOptions"])
                    this.findingTypeOptions!.push(FindingTypeOption.fromJS(item));
            }
            if (Array.isArray(_data["findings"])) {
                this.findings = [] as any;
                for (let item of _data["findings"])
                    this.findings!.push(Finding.fromJS(item));
            }
            if (Array.isArray(_data["measuredValues"])) {
                this.measuredValues = [] as any;
                for (let item of _data["measuredValues"])
                    this.measuredValues!.push(MeasuredValue.fromJS(item));
            }
            this.solution = _data["solution"] ? Solution.fromJS(_data["solution"]) : <any>undefined;
            this.isManuallyCreated = _data["isManuallyCreated"];
            this.detailedDescription = _data["detailedDescription"];
            this.comment = _data["comment"];
            if (Array.isArray(_data["media"])) {
                this.media = [] as any;
                for (let item of _data["media"])
                    this.media!.push(FileLinkWithThumbnail.fromJS(item));
            }
            this.isWalkthroughEnabled = _data["isWalkthroughEnabled"];
        }
    }

    static fromJS(data: any): Checkpoint {
        data = typeof data === 'object' ? data : {};
        let result = new Checkpoint();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["image"] = this.image ? this.image.toJSON() : <any>undefined;
        data["status"] = this.status;
        data["isMandatory"] = this.isMandatory;
        if (Array.isArray(this.findingTypeOptions)) {
            data["findingTypeOptions"] = [];
            for (let item of this.findingTypeOptions)
                data["findingTypeOptions"].push(item.toJSON());
        }
        if (Array.isArray(this.findings)) {
            data["findings"] = [];
            for (let item of this.findings)
                data["findings"].push(item.toJSON());
        }
        if (Array.isArray(this.measuredValues)) {
            data["measuredValues"] = [];
            for (let item of this.measuredValues)
                data["measuredValues"].push(item.toJSON());
        }
        data["solution"] = this.solution ? this.solution.toJSON() : <any>undefined;
        data["isManuallyCreated"] = this.isManuallyCreated;
        data["detailedDescription"] = this.detailedDescription;
        data["comment"] = this.comment;
        if (Array.isArray(this.media)) {
            data["media"] = [];
            for (let item of this.media)
                data["media"].push(item.toJSON());
        }
        data["isWalkthroughEnabled"] = this.isWalkthroughEnabled;

        return data;
    }
}

export interface ICheckpoint {
    id?: string | undefined;
    description?: string | undefined;
    image?: FileLink;
    status?: CheckpointStatus;
    isMandatory?: boolean | undefined;
    findingTypeOptions?: FindingTypeOption[] | undefined;
    findings?: Finding[] | undefined;
    measuredValues?: MeasuredValue[] | undefined;
    solution?: Solution;
    isManuallyCreated:  boolean | undefined;
    detailedDescription: string | undefined;
    comment: string | undefined;
    media: FileLinkWithThumbnail[] | undefined;
    isWalkthroughEnabled?: boolean | undefined;
}

export enum CheckpointStatus {
    OK = "OK",
    NotOK = "NotOK",
    Undefined = "Undefined",
}

export class DmsProblemDetails implements IDmsProblemDetails {
    code?: number;
    messageId?: string;
    type?: string;
    title?: string;
    status?: number;
    detail?: string;
    instance?: string;

    constructor(data?: IDmsProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.messageId = _data["messageId"];
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): DmsProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new DmsProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["messageId"] = this.messageId;
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IDmsProblemDetails {
    code?: number;
    messageId?: string;
    type?: string;
    title?: string;
    status?: number;
    detail?: string;
    instance?: string;
}

export class EndApproval implements IEndApproval {
    id?: string | undefined;
    description?: string | undefined;
    descriptionLong?: string | undefined;
    price?: Prices;
    billToClientName?: string | undefined;
    approvalStatus?: string | undefined;

    constructor(data?: IEndApproval) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.descriptionLong = _data["descriptionLong"];
            this.price = _data["price"] ? Prices.fromJS(_data["price"]) : <any>undefined;
            this.billToClientName = _data["billToClientName"];
            this.approvalStatus = _data["approvalStatus"];
        }
    }

    static fromJS(data: any): EndApproval {
        data = typeof data === 'object' ? data : {};
        let result = new EndApproval();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["descriptionLong"] = this.descriptionLong;
        data["price"] = this.price ? this.price.toJSON() : <any>undefined;
        data["billToClientName"] = this.billToClientName;
        data["approvalStatus"] = this.approvalStatus;
        return data;
    }
}

export interface IEndApproval {
    id?: string | undefined;
    description?: string | undefined;
    descriptionLong?: string | undefined;
    price?: Prices;
    billToClientName?: string | undefined;
    approvalStatus?: string | undefined;
}

export class FileLink implements IFileLink {
    mimeType!: FileLinkCaptureMIMEType;
    storage!: StorageType;
    externalId?: string | undefined;
    url?: string | undefined;
    id!: string;

    constructor(data?: IFileLink) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mimeType = _data["mimeType"];
            this.storage = _data["storage"];
            this.externalId = _data["externalId"];
            this.url = _data["url"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): FileLink {
        data = typeof data === 'object' ? data : {};
        let result = new FileLink();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mimeType"] = this.mimeType;
        data["storage"] = this.storage;
        data["externalId"] = this.externalId;
        data["url"] = this.url;
        data["id"] = this.id;
        return data;
    }
}

export interface IFileLink {
    mimeType: FileLinkCaptureMIMEType;
    storage: StorageType;
    externalId?: string | undefined;
    url?: string | undefined;
    id: string;
}

export enum FileLinkCaptureMIMEType {
    Application_pdf = "Application_pdf",
    Image_jpeg = "Image_jpeg",
    Image_png = "Image_png",
    Video_mp4 = "Video_mp4",
    Video_mpeg = "Video_mpeg",
}

export class FileLinkWithThumbnail implements IFileLinkWithThumbnail {
    mimeType!: FileLinkCaptureMIMEType;
    storage!: StorageType;
    externalId?: string | undefined;
    url?: string | undefined;
    id!: string;
    thumbnail?: FileLink;

    constructor(data?: IFileLinkWithThumbnail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mimeType = _data["mimeType"];
            this.storage = _data["storage"];
            this.externalId = _data["externalId"];
            this.url = _data["url"];
            this.id = _data["id"];
            this.thumbnail = _data["thumbnail"] ? FileLink.fromJS(_data["thumbnail"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FileLinkWithThumbnail {
        data = typeof data === 'object' ? data : {};
        let result = new FileLinkWithThumbnail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mimeType"] = this.mimeType;
        data["storage"] = this.storage;
        data["externalId"] = this.externalId;
        data["url"] = this.url;
        data["id"] = this.id;
        data["thumbnail"] = this.thumbnail ? this.thumbnail.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFileLinkWithThumbnail {
    mimeType: FileLinkCaptureMIMEType;
    storage: StorageType;
    externalId?: string | undefined;
    url?: string | undefined;
    id: string;
    thumbnail?: FileLink;
}

export class Finding implements IFinding {
    x?: number | undefined;
    y?: number | undefined;
    id?: string | undefined;
    false?: number | undefined;
    findingType?: FindingType;
    solution?: Solution;
    comment?: string | undefined;
    media?: FileLinkWithThumbnail[] | undefined;

    constructor(data?: IFinding) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.x = _data["x"];
            this.y = _data["y"];
            this.id = _data["id"];
            this.false = _data["false"];
            this.findingType = _data["findingType"] ? FindingType.fromJS(_data["findingType"]) : <any>undefined;
            this.solution = _data["solution"] ? Solution.fromJS(_data["solution"]) : <any>undefined;
            this.comment = _data["comment"];
            if (Array.isArray(_data["media"])) {
                this.media = [] as any;
                for (let item of _data["media"])
                    this.media!.push(FileLinkWithThumbnail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Finding {
        data = typeof data === 'object' ? data : {};
        let result = new Finding();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["x"] = this.x;
        data["y"] = this.y;
        data["id"] = this.id;
        data["false"] = this.false;
        data["findingType"] = this.findingType ? this.findingType.toJSON() : <any>undefined;
        data["solution"] = this.solution ? this.solution.toJSON() : <any>undefined;
        data["comment"] = this.comment;
        if (Array.isArray(this.media)) {
            data["media"] = [];
            for (let item of this.media)
                data["media"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFinding {
    x?: number | undefined;
    y?: number | undefined;
    id?: string | undefined;
    false?: number | undefined;
    findingType?: FindingType;
    solution?: Solution;
    comment?: string | undefined;
    media?: FileLinkWithThumbnail[] | undefined;
}

export class FindingType implements IFindingType {
    id?: string | undefined;
    description?: string | undefined;

    constructor(data?: IFindingType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): FindingType {
        data = typeof data === 'object' ? data : {};
        let result = new FindingType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        return data;
    }
}

export interface IFindingType {
    id?: string | undefined;
    description?: string | undefined;
}

export class FindingTypeOption implements IFindingTypeOption {
    id?: string | undefined;
    description?: string | undefined;
    multipleUse?: boolean | undefined;
    color?: FindingTypeOptionColor;

    constructor(data?: IFindingTypeOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.multipleUse = _data["multipleUse"];
            this.color = _data["color"];
        }
    }

    static fromJS(data: any): FindingTypeOption {
        data = typeof data === 'object' ? data : {};
        let result = new FindingTypeOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["multipleUse"] = this.multipleUse;
        data["color"] = this.color;
        return data;
    }
}

export interface IFindingTypeOption {
    id?: string | undefined;
    description?: string | undefined;
    multipleUse?: boolean | undefined;
    color?: FindingTypeOptionColor;
}

export enum FindingTypeOptionColor {
    Yellow = "Yellow",
    Red = "Red",
}

export class GetDetailsMappedResponse implements IGetDetailsMappedResponse {
    serviceAdvisorId?: string | undefined;
    id?: string | undefined;
    documentNo?: string | undefined;
    appointmentDate?: string | undefined;
    locationId?: string | undefined;
    customer?: Order_Customer;
    vehicles?: Order_Vehicle;
    serviceJobs?: ServiceJob[] | undefined;

    constructor(data?: IGetDetailsMappedResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceAdvisorId = _data["serviceAdvisorId"];
            this.id = _data["id"];
            this.documentNo = _data["documentNo"];
            this.appointmentDate = _data["appointmentDate"];
            this.locationId = _data["locationId"];
            this.customer = _data["customer"] ? Order_Customer.fromJS(_data["customer"]) : <any>undefined;
            this.vehicles = _data["vehicles"] ? Order_Vehicle.fromJS(_data["vehicles"]) : <any>undefined;
            if (Array.isArray(_data["serviceJobs"])) {
                this.serviceJobs = [] as any;
                for (let item of _data["serviceJobs"])
                    this.serviceJobs!.push(ServiceJob.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDetailsMappedResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDetailsMappedResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceAdvisorId"] = this.serviceAdvisorId;
        data["id"] = this.id;
        data["documentNo"] = this.documentNo;
        data["appointmentDate"] = this.appointmentDate;
        data["locationId"] = this.locationId;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["vehicles"] = this.vehicles ? this.vehicles.toJSON() : <any>undefined;
        if (Array.isArray(this.serviceJobs)) {
            data["serviceJobs"] = [];
            for (let item of this.serviceJobs)
                data["serviceJobs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetDetailsMappedResponse {
    serviceAdvisorId?: string | undefined;
    id?: string | undefined;
    documentNo?: string | undefined;
    appointmentDate?: string | undefined;
    locationId?: string | undefined;
    customer?: Order_Customer;
    vehicles?: Order_Vehicle;
    serviceJobs?: ServiceJob[] | undefined;
}

export class GetDetailsResponse implements IGetDetailsResponse {
    companyId?: string | undefined;
    order?: GetDetailsMappedResponse;
    token?: string | undefined;
    title: any;

    constructor(data?: IGetDetailsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.order = _data["order"] ? GetDetailsMappedResponse.fromJS(_data["order"]) : <any>undefined;
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): GetDetailsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDetailsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["token"] = this.token;
        return data;
    }
}

export interface IGetDetailsResponse {
    companyId?: string | undefined;
    order?: GetDetailsMappedResponse;
    token?: string | undefined;
}

export class MeasuredValue implements IMeasuredValue {
    id!: string;
    description!: string;
    unitOfMeasure?: string | undefined;
    type!: MeasuredValueType;
    isRange?: boolean | undefined;
    minimumValue?: string | undefined;
    maximumValue?: string | undefined;
    stepValue?: string | undefined;
    isMandatory?: boolean | undefined;
    valueOptions?: string[] | undefined;
    previousValue?: string | undefined;
    value?: string | undefined;
    comment?: string | undefined;
    media?: FileLinkWithThumbnail[] | undefined;

    constructor(data?: IMeasuredValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.unitOfMeasure = _data["unitOfMeasure"];
            this.type = _data["type"];
            this.isRange = _data["isRange"];
            this.minimumValue = _data["minimumValue"];
            this.maximumValue = _data["maximumValue"];
            this.stepValue = _data["stepValue"];
            this.isMandatory = _data["isMandatory"];
            if (Array.isArray(_data["valueOptions"])) {
                this.valueOptions = [] as any;
                for (let item of _data["valueOptions"])
                    this.valueOptions!.push(item);
            }
            this.previousValue = _data["previousValue"];
            this.value = _data["value"];
            this.comment = _data["comment"];
            if (Array.isArray(_data["media"])) {
                this.media = [] as any;
                for (let item of _data["media"])
                    this.media!.push(FileLinkWithThumbnail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MeasuredValue {
        data = typeof data === 'object' ? data : {};
        let result = new MeasuredValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["unitOfMeasure"] = this.unitOfMeasure;
        data["type"] = this.type;
        data["isRange"] = this.isRange;
        data["minimumValue"] = this.minimumValue;
        data["maximumValue"] = this.maximumValue;
        data["stepValue"] = this.stepValue;
        data["isMandatory"] = this.isMandatory;
        if (Array.isArray(this.valueOptions)) {
            data["valueOptions"] = [];
            for (let item of this.valueOptions)
                data["valueOptions"].push(item);
        }
        data["previousValue"] = this.previousValue;
        data["value"] = this.value;
        data["comment"] = this.comment;
        if (Array.isArray(this.media)) {
            data["media"] = [];
            for (let item of this.media)
                data["media"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMeasuredValue {
    id: string;
    description: string;
    unitOfMeasure?: string | undefined;
    type: MeasuredValueType;
    isRange?: boolean | undefined;
    minimumValue?: string | undefined;
    maximumValue?: string | undefined;
    stepValue?: string | undefined;
    isMandatory?: boolean | undefined;
    valueOptions?: string[] | undefined;
    previousValue?: string | undefined;
    value?: string | undefined;
    comment?: string | undefined;
    media?: FileLinkWithThumbnail[] | undefined;
}

export enum MeasuredValueType {
    String = "String",
    Integer = "Integer",
    Decimal = "Decimal",
    Date = "Date",
    Datetime = "Datetime",
    Boolean = "Boolean",
}

export class Order_Customer implements IOrder_Customer {
    name?: string | undefined;

    constructor(data?: IOrder_Customer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): Order_Customer {
        data = typeof data === 'object' ? data : {};
        let result = new Order_Customer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface IOrder_Customer {
    name?: string | undefined;
}

export class Order_Vehicle implements IOrder_Vehicle {
    id!: string;
    vin?: string | undefined;
    licenseNo!: string;
    make?: string | undefined;
    model?: string | undefined;
    modelYear?: number | undefined;
    color?: string | undefined;
    mileage?: number | undefined;
    initialRegistrationDate?: string | undefined;
    nextGeneralInspectionDate?: string | undefined;
    lastVisitDate?: string | undefined;

    constructor(data?: IOrder_Vehicle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.vin = _data["vin"];
            this.licenseNo = _data["licenseNo"];
            this.make = _data["make"];
            this.model = _data["model"];
            this.modelYear = _data["modelYear"];
            this.color = _data["color"];
            this.mileage = _data["mileage"];
            this.initialRegistrationDate = _data["initialRegistrationDate"];
            this.nextGeneralInspectionDate = _data["nextGeneralInspectionDate"];
            this.lastVisitDate = _data["lastVisitDate"];
        }
    }

    static fromJS(data: any): Order_Vehicle {
        data = typeof data === 'object' ? data : {};
        let result = new Order_Vehicle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["vin"] = this.vin;
        data["licenseNo"] = this.licenseNo;
        data["make"] = this.make;
        data["model"] = this.model;
        data["modelYear"] = this.modelYear;
        data["color"] = this.color;
        data["mileage"] = this.mileage;
        data["initialRegistrationDate"] = this.initialRegistrationDate;
        data["nextGeneralInspectionDate"] = this.nextGeneralInspectionDate;
        data["lastVisitDate"] = this.lastVisitDate;
        return data;
    }
}

export interface IOrder_Vehicle {
    id: string;
    vin?: string | undefined;
    licenseNo: string;
    make?: string | undefined;
    model?: string | undefined;
    modelYear?: number | undefined;
    color?: string | undefined;
    mileage?: number | undefined;
    initialRegistrationDate?: string | undefined;
    nextGeneralInspectionDate?: string | undefined;
    lastVisitDate?: string | undefined;
}

export class Price implements IPrice {
    grossPrice?: number | undefined;
    netPrice?: number | undefined;
    currency?: string | undefined;
    taxes?: Price_Taxes[] | undefined;
    discount?: Price_Discount | undefined;
    constructor(data?: IPrice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.grossPrice = _data["grossPrice"];
            this.netPrice = _data["netPrice"];
            this.currency = _data["currency"];
            if (Array.isArray(_data["taxes"])) {
                this.taxes = [] as any;
                for (let item of _data["taxes"])
                    this.taxes!.push(Price_Taxes.fromJS(item));
            }
            this.discount = _data["discount"] ? Price_Discount.fromJS(_data["discount"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Price {
        data = typeof data === 'object' ? data : {};
        let result = new Price();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["grossPrice"] = this.grossPrice;
        data["netPrice"] = this.netPrice;
        data["currency"] = this.currency;
        if (Array.isArray(this.taxes)) {
            data["taxes"] = [];
            for (let item of this.taxes)
                data["taxes"].push(item.toJSON());
        }
        this.discount ? this.discount.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPrice {
    grossPrice?: number | undefined;
    netPrice?: number | undefined;
    currency?: string | undefined;
    taxes?: Price_Taxes[] | undefined;
    discount?: Price_Discount | undefined;
}

export class PriceTaxes implements IPriceTaxes {
    type?: PriceTaxesType;
    value?: number;
    percent?: number;

    constructor(data?: IPriceTaxes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.value = _data["value"];
            this.percent = _data["percent"];
        }
    }

    static fromJS(data: any): PriceTaxes {
        data = typeof data === 'object' ? data : {};
        let result = new PriceTaxes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["value"] = this.value;
        data["percent"] = this.percent;
        return data;
    }
}

export interface IPriceTaxes {
    type?: PriceTaxesType;
    value?: number;
    percent?: number;
}

export enum PriceTaxesType {
    Vat = "Vat",
    Gst = "Gst",
}

export class Price_Discount implements IPrice_Discount {
    amount: number | undefined;
    value: number | undefined;
    percent: number | undefined;

    constructor(data?: IPrice_Discount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }

    }
    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.value = _data["value"];
            this.percent = _data["percent"];
        }
    }

    static fromJS(data: any): Price_Discount {
        data = typeof data === 'object' ? data : {};
        let result = new Price_Discount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["value"] = this.value;
        data["percent"] = this.percent;
        return data;
    }
}

export interface IPrice_Discount {
    amount: number | undefined;
    value: number | undefined;
    percent: number | undefined;
}

export class Price_Taxes implements IPrice_Taxes {
    type?: Price_TaxesType;
    value?: number | undefined;
    percent?: number | undefined;

    constructor(data?: IPrice_Taxes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.value = _data["value"];
            this.percent = _data["percent"];
        }
    }

    static fromJS(data: any): Price_Taxes {
        data = typeof data === 'object' ? data : {};
        let result = new Price_Taxes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["value"] = this.value;
        data["percent"] = this.percent;
        return data;
    }
}

export interface IPrice_Taxes {
    type?: Price_TaxesType;
    value?: number | undefined;
    percent?: number | undefined;
}

export enum Price_TaxesType {
    VAT = "VAT",
    GST = "GST",
}

export class Prices implements IPrices {
    grossPrice?: number;
    netPrice?: number;
    currency?: string | undefined;
    taxes?: PriceTaxes[] | undefined;

    constructor(data?: IPrices) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.grossPrice = _data["grossPrice"];
            this.netPrice = _data["netPrice"];
            this.currency = _data["currency"];
            if (Array.isArray(_data["taxes"])) {
                this.taxes = [] as any;
                for (let item of _data["taxes"])
                    this.taxes!.push(PriceTaxes.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Prices {
        data = typeof data === 'object' ? data : {};
        let result = new Prices();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["grossPrice"] = this.grossPrice;
        data["netPrice"] = this.netPrice;
        data["currency"] = this.currency;
        if (Array.isArray(this.taxes)) {
            data["taxes"] = [];
            for (let item of this.taxes)
                data["taxes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPrices {
    grossPrice?: number;
    netPrice?: number;
    currency?: string | undefined;
    taxes?: PriceTaxes[] | undefined;
}

export class ServiceJob implements IServiceJob {
    forEach(arg0: (element: any) => void) {
        throw new Error('Method not implemented.');
    }
    map(arg0: (x: ServiceJob) => EndApproval): EndApproval[] {
        throw new Error('Method not implemented.');
    }
    price?: Price;
    id?: string | undefined;
    description?: string | undefined;
    descritpionLong?: string | undefined;
    approvalStatus?: string | undefined;
    billToCustomerName?: string | undefined;
    checkpoints?: Checkpoint[] | undefined;
    item?: ServiceLineWithPrice[] | undefined;
    labor?: ServiceLineWithPrice[] | undefined;
    other?: ServiceLineWithPrice[] | undefined;
    total?: TotalAmmountForServiceLine[] | undefined;

    constructor(data?: IServiceJob) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.price = _data["price"] ? Price.fromJS(_data["price"]) : <any>undefined;
            this.id = _data["id"];
            this.description = _data["description"];
            this.descritpionLong = _data["descritpionLong"];
            this.approvalStatus = _data["approvalStatus"];
            this.billToCustomerName = _data["billToCustomerName"];
            if (Array.isArray(_data["checkpoints"])) {
                this.checkpoints = [] as any;
                for (let item of _data["checkpoints"])
                    this.checkpoints!.push(Checkpoint.fromJS(item));
            }
            if (Array.isArray(_data["item"])) {
                this.item = [] as any;
                for (let item of _data["item"])
                    this.item!.push(ServiceLineWithPrice.fromJS(item));
            }
            if (Array.isArray(_data["labor"])) {
                this.labor = [] as any;
                for (let item of _data["labor"])
                    this.labor!.push(ServiceLineWithPrice.fromJS(item));
            }
            if (Array.isArray(_data["other"])) {
                this.other = [] as any;
                for (let item of _data["other"])
                    this.other!.push(ServiceLineWithPrice.fromJS(item));
            }
            if (Array.isArray(_data["total"])) {
                this.total = [] as any;
                for (let item of _data["total"])
                    this.total!.push(TotalAmmountForServiceLine.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ServiceJob {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceJob();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["price"] = this.price ? this.price.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["description"] = this.description;
        data["descritpionLong"] = this.descritpionLong;
        data["approvalStatus"] = this.approvalStatus;
        data["billToCustomerName"] = this.billToCustomerName;
        if (Array.isArray(this.checkpoints)) {
            data["checkpoints"] = [];
            for (let item of this.checkpoints)
                data["checkpoints"].push(item.toJSON());
        }
        if (Array.isArray(this.item)) {
            data["item"] = [];
            for (let item of this.item)
                data["item"].push(item.toJSON());
        }
        if (Array.isArray(this.labor)) {
            data["labor"] = [];
            for (let item of this.labor)
                data["labor"].push(item.toJSON());
        }
        if (Array.isArray(this.other)) {
            data["other"] = [];
            for (let item of this.other)
                data["other"].push(item.toJSON());
        }
        if (Array.isArray(this.total)) {
            data["total"] = [];
            for (let item of this.total)
                data["total"].push(item.toJSON());
        }
        return data;
    }
}

export interface IServiceJob {
    price?: Price;
    id?: string | undefined;
    description?: string | undefined;
    descritpionLong?: string | undefined;
    approvalStatus?: string | undefined;
    billToCustomerName?: string | undefined;
    checkpoints?: Checkpoint[] | undefined;
    item?: ServiceLineWithPrice[] | undefined;
    labor?: ServiceLineWithPrice[] | undefined;
    other?: ServiceLineWithPrice[] | undefined;
    total?: TotalAmmountForServiceLine[] | undefined;
}

export class ServiceLineWithPrice implements IServiceLineWithPrice {
    jobId?: string | undefined;
    type?: string | undefined;
    no?: string | undefined;
    description!: string;
    quantity?: number | undefined;
    unitOfMeasure?: string | undefined;
    price?: Price;

    constructor(data?: IServiceLineWithPrice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobId = _data["jobId"];
            this.type = _data["type"];
            this.no = _data["no"];
            this.description = _data["description"];
            this.quantity = _data["quantity"];
            this.unitOfMeasure = _data["unitOfMeasure"];
            this.price = _data["price"] ? Price.fromJS(_data["price"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ServiceLineWithPrice {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceLineWithPrice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobId"] = this.jobId;
        data["type"] = this.type;
        data["no"] = this.no;
        data["description"] = this.description;
        data["quantity"] = this.quantity;
        data["unitOfMeasure"] = this.unitOfMeasure;
        data["price"] = this.price ? this.price.toJSON() : <any>undefined;
        return data;
    }
}

export interface IServiceLineWithPrice {
    jobId?: string | undefined;
    type?: string | undefined;
    no?: string | undefined;
    description: string;
    quantity?: number | undefined;
    unitOfMeasure?: string | undefined;
    price?: Price;
}

export class Solution implements ISolution {
    id!: string;
    description!: string;

    constructor(data?: ISolution) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): Solution {
        data = typeof data === 'object' ? data : {};
        let result = new Solution();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        return data;
    }
}

export interface ISolution {
    id: string;
    description: string;
}

export enum StorageType {
    Backend = "Backend",
    External = "External",
}

export class TotalAmmountForServiceLine implements ITotalAmmountForServiceLine {
    id?: string | undefined;
    type?: string | undefined;
    price?: Price;

    constructor(data?: ITotalAmmountForServiceLine) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.price = _data["price"] ? Price.fromJS(_data["price"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TotalAmmountForServiceLine {
        data = typeof data === 'object' ? data : {};
        let result = new TotalAmmountForServiceLine();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["price"] = this.price ? this.price.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITotalAmmountForServiceLine {
    id?: string | undefined;
    type?: string | undefined;
    price?: Price;
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    return _observableThrow(new ApiException(message, status, response, headers, result));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}




export class ChecklistDetailsResponse implements IChecklistDetailsResponse {
    id?: string | undefined;
    name?: string | undefined;
    status?: string | undefined;
    submittedDate?: string | undefined;
    categories?: ChecklistDetailsCategories[] | undefined;
    order?: ChecklistDetailsOrder | undefined;


    constructor(data?: IChecklistDetailsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.status = _data["status"];
            this.submittedDate = _data["submittedDate"];

            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let categories of _data["categories"])
                    this.categories!.push(ChecklistDetailsCategories.fromJS(categories));
            }

            this.order = _data["order"] ? ChecklistDetailsOrder.fromJS(_data["order"]) : <any>undefined;

        }
    }

    static fromJS(data: any): ChecklistDetailsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ChecklistDetailsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["status"] = this.status;
        data["submittedDate"] = this.submittedDate;
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let categories of this.categories)
                data["categories"].push(categories.toJSON());
        }
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;

        return data;
    }
}

export interface IChecklistDetailsResponse {
    id?: string | undefined;
    description?: string | undefined;
    status?: string | undefined;
    submittedDate?: string | undefined;
    categories?: ChecklistDetailsCategories[] | undefined;
    order?: ChecklistDetailsOrder | undefined;
}

export class ChecklistDetailsCategories implements IChecklistDetailsCategories {
    name?: string | undefined;
    checkpoints?: ChecklistDetailsCheckPoints[] | undefined;


    constructor(data?: IChecklistDetailsCategories) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];

            if (Array.isArray(_data["checkpoints"])) {
                this.checkpoints = [] as any;
                for (let checkpoints of _data["checkpoints"])
                    this.checkpoints!.push(ChecklistDetailsCheckPoints.fromJS(checkpoints));
            }

        }
    }

    static fromJS(data: any): ChecklistDetailsCategories {
        data = typeof data === 'object' ? data : {};
        let result = new ChecklistDetailsCategories();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.checkpoints)) {
            data["checkpoints"] = [];
            for (let checkpoints of this.checkpoints)
                data["checkpoints"].push(checkpoints.toJSON());
        }

        return data;
    }
}

export interface IChecklistDetailsCategories {
    name?: string | undefined;
    checkpoints?: ChecklistDetailsCheckPoints[] | undefined;
}

export class ChecklistDetailsCheckPoints implements IChecklistDetailsCheckPoints {
    id?: string | undefined;
    description?: string | undefined;
    image?: ChecklistDetailsFileLink;
    status?: String | undefined;
    isMandatory?: boolean | undefined;
    findingTypeOptions?: ChecklistDetailsFindingTypeOption[] | undefined;
    findings?: ChecklistDetailsFinding[] | undefined;
    measuredValues?: ChecklistDetailsMeasuredValue[] | undefined;
    solution?: Solution;
    isManuallyCreated:  boolean | undefined;
    detailedDescription: string | undefined;
    comment: string | undefined;
    media: FileLinkWithThumbnail[] | undefined;
    isWalkthroughEnabled?: boolean | undefined;

    constructor(data?: IChecklistDetailsCheckPoints) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.image = _data["image"] ? ChecklistDetailsFileLink.fromJS(_data["image"]) : <any>undefined;
            this.status = _data["status"];
            this.isMandatory = _data["isMandatory"];
            if (Array.isArray(_data["findingTypeOptions"])) {
                this.findingTypeOptions = [] as any;
                for (let item of _data["findingTypeOptions"])
                    this.findingTypeOptions!.push(ChecklistDetailsFindingTypeOption.fromJS(item));
            }
            if (Array.isArray(_data["findings"])) {
                this.findings = [] as any;
                for (let item of _data["findings"])
                    this.findings!.push(ChecklistDetailsFinding.fromJS(item));
            }
            if (Array.isArray(_data["measuredValues"])) {
                this.measuredValues = [] as any;
                for (let item of _data["measuredValues"])
                    this.measuredValues!.push(ChecklistDetailsMeasuredValue.fromJS(item));
            }
            this.solution = _data["solution"] ? Solution.fromJS(_data["solution"]) : <any>undefined;
            this.isManuallyCreated = _data["isManuallyCreated"];
            this.detailedDescription = _data["detailedDescription"];
            this.comment = _data["comment"];
            if (Array.isArray(_data["media"])) {
                this.media = [] as any;
                for (let item of _data["media"])
                    this.media!.push(FileLinkWithThumbnail.fromJS(item));
            }
            this.isWalkthroughEnabled = _data["isWalkthroughEnabled"];
        }
    }

    static fromJS(data: any): ChecklistDetailsCheckPoints {
        data = typeof data === 'object' ? data : {};
        let result = new ChecklistDetailsCheckPoints();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["image"] = this.image ? this.image.toJSON() : <any>undefined;
        data["status"] = this.status;
        data["isMandatory"] = this.isMandatory;
        if (Array.isArray(this.findingTypeOptions)) {
            data["findingTypeOptions"] = [];
            for (let item of this.findingTypeOptions)
                data["findingTypeOptions"].push(item.toJSON());
        }
        if (Array.isArray(this.findings)) {
            data["findinFindingsgs"] = [];
            for (let item of this.findings)
                data["findings"].push(item.toJSON());
        }
        if (Array.isArray(this.measuredValues)) {
            data["measuredValues"] = [];
            for (let item of this.measuredValues)
                data["measuredValues"].push(item.toJSON());
        }
        data["solution"] = this.solution ? this.solution.toJSON() : <any>undefined;
        data["isManuallyCreated"] = this.isManuallyCreated;
        data["detailedDescription"] = this.detailedDescription;
        data["comment"] = this.comment;
        if (Array.isArray(this.media)) {
            data["media"] = [];
            for (let item of this.media)
                data["media"].push(item.toJSON());
        }
        data["isWalkthroughEnabled"] = this.isWalkthroughEnabled;
        
        return data;
    }
}

export interface IChecklistDetailsCheckPoints {
    id?: string | undefined;
    description?: string | undefined;
    image?: ChecklistDetailsFileLink;
    status?: String | undefined;
    isMandatory?: boolean | undefined;
    findingTypeOptions?: ChecklistDetailsFindingTypeOption[] | undefined;
    findings?: ChecklistDetailsFinding[] | undefined;
    measuredValues?: ChecklistDetailsMeasuredValue[] | undefined;
    solution?: Solution;
    isManuallyCreated:  boolean | undefined;
    detailedDescription: string | undefined;
    comment: string | undefined;
    media: FileLinkWithThumbnail[] | undefined;
    isWalkthroughEnabled?: boolean | undefined;
}


export class ChecklistDetailsFindingTypeOption implements IChecklistDetailsFindingTypeOption {
    id?: string | undefined;
    description?: string | undefined;
    multipleUse?: boolean | undefined;
    color?: string | undefined;

    constructor(data?: IChecklistDetailsFindingTypeOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.multipleUse = _data["multipleUse"];
            this.color = _data["color"];
        }
    }

    static fromJS(data: any): ChecklistDetailsFindingTypeOption {
        data = typeof data === 'object' ? data : {};
        let result = new ChecklistDetailsFindingTypeOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["multipleUse"] = this.multipleUse;
        data["color"] = this.color;
        return data;
    }
}

export interface IChecklistDetailsFindingTypeOption {
    id?: string | undefined;
    description?: string | undefined;
    multipleUse?: boolean | undefined;
    color?: string | undefined;
}



export class ChecklistDetailsFinding implements IChecklistDetailsFinding {
    x?: number | undefined;
    y?: number | undefined;
    id?: string | undefined;
    no?: number | undefined;
    findingType?: ChecklistDetailsFindingType;
    solution?: ChecklistDetailsSolution;
    comment?: string | undefined;
    media?: ChecklistDetailsFileLinkWithThumbnail[] | undefined;

    constructor(data?: IChecklistDetailsFinding) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.x = _data["x"];
            this.y = _data["y"];
            this.id = _data["id"];
            this.no = _data["no"];
            this.findingType = _data["findingType"] ? ChecklistDetailsFindingType.fromJS(_data["findingType"]) : <any>undefined;
            this.solution = _data["solution"] ? ChecklistDetailsSolution.fromJS(_data["solution"]) : <any>undefined;
            this.comment = _data["comment"];
            if (Array.isArray(_data["media"])) {
                this.media = [] as any;
                for (let item of _data["media"])
                    this.media!.push(ChecklistDetailsFileLinkWithThumbnail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ChecklistDetailsFinding {
        data = typeof data === 'object' ? data : {};
        let result = new ChecklistDetailsFinding();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["x"] = this.x;
        data["y"] = this.y;
        data["id"] = this.id;
        data["no"] = this.no;
        data["findingType"] = this.findingType ? this.findingType.toJSON() : <any>undefined;
        data["solution"] = this.solution ? this.solution.toJSON() : <any>undefined;
        data["comment"] = this.comment;
        if (Array.isArray(this.media)) {
            data["media"] = [];
            for (let item of this.media)
                data["media"].push(item.toJSON());
        }
        return data;
    }
}

export interface IChecklistDetailsFinding {
    x?: number | undefined;
    y?: number | undefined;
    id?: string | undefined;
    No?: number | undefined;
    findingType?: ChecklistDetailsFindingType;
    solution?: ChecklistDetailsSolution;
    comment?: string | undefined;
    media?: ChecklistDetailsFileLinkWithThumbnail[] | undefined;
}

export class ChecklistDetailsFindingType implements IChecklistDetailsFindingType {
    id?: string | undefined;
    description?: string | undefined;

    constructor(data?: IChecklistDetailsFindingType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): ChecklistDetailsFindingType {
        data = typeof data === 'object' ? data : {};
        let result = new ChecklistDetailsFindingType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        return data;
    }
}

export interface IChecklistDetailsFindingType {
    id?: string | undefined;
    description?: string | undefined;
}

export class ChecklistDetailsSolution implements IChecklistDetailsSolution {
    id!: string;
    description!: string;

    constructor(data?: IChecklistDetailsSolution) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): ChecklistDetailsSolution {
        data = typeof data === 'object' ? data : {};
        let result = new ChecklistDetailsSolution();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        return data;
    }
}

export interface IChecklistDetailsSolution {
    id: string;
    description: string;
}

export class ChecklistDetailsFileLinkWithThumbnail implements IChecklistDetailsFileLinkWithThumbnail {
    mimeType!: FileLinkCaptureMIMEType;
    storage!: StorageType;
    externalId?: string | undefined;
    url?: string | undefined;
    id!: string;
    thumbnail?: ChecklistDetailsFileLinkWithThumbnail;

    constructor(data?: IChecklistDetailsFileLinkWithThumbnail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mimeType = _data["mimeType"];
            this.storage = _data["storage"];
            this.externalId = _data["externalId"];
            this.url = _data["url"];
            this.id = _data["id"];
            this.thumbnail = _data["thumbnail"] ? ChecklistDetailsFileLinkWithThumbnail.fromJS(_data["thumbnail"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ChecklistDetailsFileLinkWithThumbnail {
        data = typeof data === 'object' ? data : {};
        let result = new ChecklistDetailsFileLinkWithThumbnail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mimeType"] = this.mimeType;
        data["storage"] = this.storage;
        data["externalId"] = this.externalId;
        data["url"] = this.url;
        data["id"] = this.id;
        data["thumbnail"] = this.thumbnail ? this.thumbnail.toJSON() : <any>undefined;
        return data;
    }
}

export interface IChecklistDetailsFileLinkWithThumbnail {
    mimeType: FileLinkCaptureMIMEType;
    storage: StorageType;
    externalId?: string | undefined;
    url?: string | undefined;
    id: string;
    thumbnail?: ChecklistDetailsFileLinkWithThumbnail;
}


export class ChecklistDetailsMeasuredValue implements IChecklistDetailsMeasuredValue {
    id!: string;
    description!: string;
    unitOfMeasure?: string | undefined;
    type!: MeasuredValueType;
    isRange?: boolean | undefined;
    minimumValue?: string | undefined;
    maximumValue?: string | undefined;
    stepValue?: string | undefined;
    isMandatory?: boolean | undefined;
    valueOptions?: string[] | undefined;
    previousValue?: string | undefined;
    value?: string | undefined;
    comment?: string | undefined;
    media?: ChecklistDetailsFileLinkWithThumbnail[] | undefined;

    constructor(data?: IChecklistDetailsMeasuredValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.unitOfMeasure = _data["unitOfMeasure"];
            this.type = _data["type"];
            this.isRange = _data["isRange"];
            this.minimumValue = _data["minimumValue"];
            this.maximumValue = _data["maximumValue"];
            this.stepValue = _data["stepValue"];
            this.isMandatory = _data["isMandatory"];
            if (Array.isArray(_data["valueOptions"])) {
                this.valueOptions = [] as any;
                for (let item of _data["valueOptions"])
                    this.valueOptions!.push(item);
            }
            this.previousValue = _data["previousValue"];
            this.value = _data["value"];
            this.comment = _data["comment"];
            if (Array.isArray(_data["media"])) {
                this.media = [] as any;
                for (let item of _data["media"])
                    this.media!.push(ChecklistDetailsFileLinkWithThumbnail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ChecklistDetailsMeasuredValue {
        data = typeof data === 'object' ? data : {};
        let result = new ChecklistDetailsMeasuredValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["unitOfMeasure"] = this.unitOfMeasure;
        data["type"] = this.type;
        data["isRange"] = this.isRange;
        data["minimumValue"] = this.minimumValue;
        data["maximumValue"] = this.maximumValue;
        data["stepValue"] = this.stepValue;
        data["isMandatory"] = this.isMandatory;
        if (Array.isArray(this.valueOptions)) {
            data["valueOptions"] = [];
            for (let item of this.valueOptions)
                data["valueOptions"].push(item);
        }
        data["previousValue"] = this.previousValue;
        data["value"] = this.value;
        data["comment"] = this.comment;
        if (Array.isArray(this.media)) {
            data["media"] = [];
            for (let item of this.media)
                data["media"].push(item.toJSON());
        }
        return data;
    }
}

export interface IChecklistDetailsMeasuredValue {
    id: string;
    description: string;
    unitOfMeasure?: string | undefined;
    type: MeasuredValueType;
    isRange?: boolean | undefined;
    minimumValue?: string | undefined;
    maximumValue?: string | undefined;
    stepValue?: string | undefined;
    isMandatory?: boolean | undefined;
    valueOptions?: string[] | undefined;
    previousValue?: string | undefined;
    value?: string | undefined;
    comment?: string | undefined;
    media?: ChecklistDetailsFileLinkWithThumbnail[] | undefined;
}

export class ChecklistDetailsFileLink implements IChecklistDetailsFileLink {
    mimeType!: FileLinkCaptureMIMEType;
    storage!: StorageType;
    externalId?: string | undefined;
    url?: string | undefined;
    id!: string;

    constructor(data?: IChecklistDetailsFileLink) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mimeType = _data["mimeType"];
            this.storage = _data["storage"];
            this.externalId = _data["externalId"];
            this.url = _data["url"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ChecklistDetailsFileLink {
        data = typeof data === 'object' ? data : {};
        let result = new ChecklistDetailsFileLink();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mimeType"] = this.mimeType;
        data["storage"] = this.storage;
        data["externalId"] = this.externalId;
        data["url"] = this.url;
        data["id"] = this.id;
        return data;
    }
}

export interface IChecklistDetailsFileLink {
    mimeType: FileLinkCaptureMIMEType;
    storage: StorageType;
    externalId?: string | undefined;
    url?: string | undefined;
    id: string;
}


export class ChecklistDetailsOrder implements IChecklistDetailsOrder {
    serviceAdvisorId?: string | undefined;
    id?: string | undefined;
    documentNo?: string | undefined;
    appointmentDate?: string | undefined;
    locationId?: string | undefined;
    customer?: ChecklistDetailsCustomer;
    vehicle?: ChecklistDetailsVehicle;
    serviceJobs?: ServiceJob[] | undefined;

    constructor(data?: IChecklistDetailsOrder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceAdvisorId = _data["serviceAdvisorId"];
            this.id = _data["id"];
            this.documentNo = _data["documentNo"];
            this.appointmentDate = _data["appointmentDate"];
            this.locationId = _data["locationId"];
            this.customer = _data["customer"] ? ChecklistDetailsCustomer.fromJS(_data["customer"]) : <any>undefined;
            this.vehicle = _data["vehicle"] ? ChecklistDetailsVehicle.fromJS(_data["vehicle"]) : <any>undefined;
            if (Array.isArray(_data["serviceJobs"])) {
                this.serviceJobs = [] as any;
                for (let item of _data["serviceJobs"])
                    this.serviceJobs!.push(ServiceJob.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ChecklistDetailsOrder {
        data = typeof data === 'object' ? data : {};
        let result = new ChecklistDetailsOrder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceAdvisorId"] = this.serviceAdvisorId;
        data["id"] = this.id;
        data["documentNo"] = this.documentNo;
        data["appointmentDate"] = this.appointmentDate;
        data["locationId"] = this.locationId;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["vehicle"] = this.vehicle ? this.vehicle.toJSON() : <any>undefined;
        if (Array.isArray(this.serviceJobs)) {
            data["serviceJobs"] = [];
            for (let item of this.serviceJobs)
                data["serviceJobs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IChecklistDetailsOrder {
    serviceAdvisorId?: string | undefined;
    id?: string | undefined;
    documentNo?: string | undefined;
    appointmentDate?: string | undefined;
    locationId?: string | undefined;
    customer?: ChecklistDetailsCustomer;
    vehicle?: ChecklistDetailsVehicle;
    serviceJobs?: ServiceJob[] | undefined;
}

export class ChecklistDetailsVehicle implements IChecklistDetailsVehicle {
    id!: string;
    vin?: string | undefined;
    licenseNo!: string;
    make?: string | undefined;
    model?: string | undefined;
    modelYear?: number | undefined;
    color?: string | undefined;
    mileage?: number | undefined;
    initialRegistrationDate?: string | undefined;
    nextGeneralInspectionDate?: string | undefined;
    lastVisitDate?: string | undefined;

    constructor(data?: IChecklistDetailsVehicle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.vin = _data["vin"];
            this.licenseNo = _data["licenseNo"];
            this.make = _data["make"];
            this.model = _data["model"];
            this.modelYear = _data["modelYear"];
            this.color = _data["color"];
            this.mileage = _data["mileage"];
            this.initialRegistrationDate = _data["initialRegistrationDate"];
            this.nextGeneralInspectionDate = _data["nextGeneralInspectionDate"];
            this.lastVisitDate = _data["lastVisitDate"];
        }
    }

    static fromJS(data: any): ChecklistDetailsVehicle {
        data = typeof data === 'object' ? data : {};
        let result = new ChecklistDetailsVehicle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["vin"] = this.vin;
        data["licenseNo"] = this.licenseNo;
        data["make"] = this.make;
        data["model"] = this.model;
        data["modelYear"] = this.modelYear;
        data["color"] = this.color;
        data["mileage"] = this.mileage;
        data["initialRegistrationDate"] = this.initialRegistrationDate;
        data["nextGeneralInspectionDate"] = this.nextGeneralInspectionDate;
        data["lastVisitDate"] = this.lastVisitDate;
        return data;
    }
}

export interface IChecklistDetailsVehicle {
    id: string;
    vin?: string | undefined;
    licenseNo: string;
    make?: string | undefined;
    model?: string | undefined;
    modelYear?: number | undefined;
    color?: string | undefined;
    mileage?: number | undefined;
    initialRegistrationDate?: string | undefined;
    nextGeneralInspectionDate?: string | undefined;
    lastVisitDate?: string | undefined;
}


export class ChecklistDetailsCustomer implements IChecklistDetailsCustomer {
    name?: string | undefined;

    constructor(data?: IChecklistDetailsCustomer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ChecklistDetailsCustomer {
        data = typeof data === 'object' ? data : {};
        let result = new ChecklistDetailsCustomer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface IChecklistDetailsCustomer {
    name?: string | undefined;
}

export class DealerMediaResponse implements IDealerMediaResponse {
    intro?: ChecklistDetailsFileLinkWithThumbnail | undefined;
    outro?: ChecklistDetailsFileLinkWithThumbnail | undefined;

    constructor(data?: IDealerMediaResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.intro = _data["intro"] ? ChecklistDetailsFileLinkWithThumbnail.fromJS(_data["intro"]) : <any>undefined;
            this.outro = _data["outro"] ? ChecklistDetailsFileLinkWithThumbnail.fromJS(_data["outro"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DealerMediaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DealerMediaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["intro"] = this.intro ? this.intro.toJSON() : <any>undefined;
        data["outro"] = this.outro ? this.outro.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDealerMediaResponse {
    intro?: ChecklistDetailsFileLinkWithThumbnail | undefined;
    outro?: ChecklistDetailsFileLinkWithThumbnail | undefined;
}

export interface ShortUrlRequest {
    shortUrl: string;
}

export class LongUrlResponse {
    longUrl: string | undefined;

    constructor(data?: any) {
        if (data) {
            this.longUrl = data.longUrl || "";
        }
    }

    static fromJS(data: any): LongUrlResponse {
        return new LongUrlResponse(data);
    }
}


export class ProformaDetails implements IProformaDetails {
    id?: string | undefined;
    invoiceNo?: string | undefined;
    locationId?: string | undefined;
    postingDate?: string | undefined;
    orderNo?: string | undefined;
    prepaymentOrderNo?: string | undefined;
    serviceAdvisor?: ServiceAdvisor;
    serviceLines?: ServiceLines[] | undefined;
    serviceJobs?: ServiceJob[] | undefined;
    price?: PriceWithDiscount;
    vehicle?: ProformaVehicle;
    customer?: Customer;
    approvalStatus?:Approvalstatus | undefined;

    constructor(data?: IProformaDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.invoiceNo = _data["invoiceNo"];
            this.locationId = _data["locationId"];
            this.postingDate = _data["postingDate"];
            this.orderNo = _data["orderNo"];
            this.approvalStatus = _data["approvalStatus"]
            this.prepaymentOrderNo = _data["prepaymentOrderNo"];
            this.serviceAdvisor = _data["serviceAdvisor"] ? ServiceAdvisor.fromJS(_data["serviceAdvisor"]) : <any>undefined;
            if (Array.isArray(_data["serviceLines"])) {
                this.serviceLines = [] as any;
                for (let item of _data["serviceLines"])
                    this.serviceLines!.push(ServiceLines.fromJS(item));
            }
            if (Array.isArray(_data["serviceJobs"])) {
                this.serviceJobs = [] as any;
                for (let item of _data["serviceJobs"])
                    this.serviceJobs!.push(ServiceJob.fromJS(item));
            }
            this.price = _data["price"] ? PriceWithDiscount.fromJS(_data["price"]) : <any>undefined;
            this.vehicle = _data["vehicle"] ? ProformaVehicle.fromJS(_data["vehicle"]) : <any>undefined;
            this.customer = _data["customer"] ? Customer.fromJS(_data["customer"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ProformaDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProformaDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["invoiceNo"] = this.invoiceNo;
        data["locationId"] = this.locationId;
        data["postingDate"] = this.postingDate;
        data["orderNo"] = this.orderNo;
        data["prepaymentOrderNo"] = this.prepaymentOrderNo;
        data["serviceAdvisor"] = this.serviceAdvisor ? this.serviceAdvisor.toJSON() : <any>undefined;
        if (Array.isArray(this.serviceLines)) {
            data["serviceLines"] = [];
            for (let item of this.serviceLines)
                data["serviceLines"].push(item.toJSON());
        }
        data["price"] = this.price ? this.price.toJSON() : <any>undefined;
        data["vehicle"] = this.vehicle ? this.vehicle.toJSON() : <any>undefined;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        return data;
    }
}

export interface IProformaDetails {
    id?: string | undefined;
    invoiceNo?: string | undefined;
    locationId?: string | undefined;
    postingDate?: string | undefined;
    orderNo?: string | undefined;
    prepaymentOrderNo?: string | undefined;
    serviceAdvisor?: ServiceAdvisor;
    serviceLines?: ServiceLines[] | undefined;
    price?: PriceWithDiscount;
    vehicle?: ProformaVehicle;
    customer?: Customer;
    approvalStatus?:string | undefined;
}

export class ServiceAdvisor implements IServiceAdvisor {
    id?: string | undefined;
    name?: string | undefined;

    constructor(data?: IServiceAdvisor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ServiceAdvisor {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceAdvisor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IServiceAdvisor {
    id?: string | undefined;
    name?: string | undefined;
}

export class Customer implements ICustomer {
    name?: string | undefined;
    address?: Address;
    phone?: Phone;
    email?: Emails;

    constructor(data?: ICustomer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : <any>undefined;
            this.phone = _data["phone"] ? Phone.fromJS(_data["phone"]) : <any>undefined;
            this.email = _data["email"] ? Emails.fromJS(_data["email"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Customer {
        data = typeof data === 'object' ? data : {};
        let result = new Customer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["phone"] = this.phone ? this.phone.toJSON() : <any>undefined;
        data["email"] = this.email ? this.email.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICustomer {
    name?: string | undefined;
    address?: Address;
    phone?: Phone;
    email?: Emails;
}

export class ProformaVehicle implements IProformaVehicle {
    id?: string | undefined;
    vin?: string | undefined;
    viN2?: string | undefined;
    licenseNo?: string | undefined;
    make?: string | undefined;
    model?: string | undefined;
    modelYear?: string | undefined;
    color?: string | undefined;
    mileage?: string | undefined;
    initialRegistrationDate?: string | undefined;
    nextGeneralInspectionDate?: string | undefined;
    lastVisitDate?: string | undefined;

    constructor(data?: IProformaVehicle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.vin = _data["vin"];
            this.viN2 = _data["viN2"];
            this.licenseNo = _data["licenseNo"];
            this.make = _data["make"];
            this.model = _data["model"];
            this.modelYear = _data["modelYear"];
            this.color = _data["color"];
            this.mileage = _data["mileage"];
            this.initialRegistrationDate = _data["initialRegistrationDate"];
            this.nextGeneralInspectionDate = _data["nextGeneralInspectionDate"];
            this.lastVisitDate = _data["lastVisitDate"];
        }
    }

    static fromJS(data: any): ProformaVehicle {
        data = typeof data === 'object' ? data : {};
        let result = new ProformaVehicle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["vin"] = this.vin;
        data["viN2"] = this.viN2;
        data["licenseNo"] = this.licenseNo;
        data["make"] = this.make;
        data["model"] = this.model;
        data["modelYear"] = this.modelYear;
        data["color"] = this.color;
        data["mileage"] = this.mileage;
        data["initialRegistrationDate"] = this.initialRegistrationDate;
        data["nextGeneralInspectionDate"] = this.nextGeneralInspectionDate;
        data["lastVisitDate"] = this.lastVisitDate;
        return data;
    }
}

export interface IProformaVehicle {
    id?: string | undefined;
    vin?: string | undefined;
    viN2?: string | undefined;
    licenseNo?: string | undefined;
    make?: string | undefined;
    model?: string | undefined;
    modelYear?: string | undefined;
    color?: string | undefined;
    mileage?: string | undefined;
    initialRegistrationDate?: string | undefined;
    nextGeneralInspectionDate?: string | undefined;
    lastVisitDate?: string | undefined;
}

export class Address implements IAddress {
    type?: AddressType;
    usage?: AddressUsage;
    postalCode?: string | undefined;
    street?: string | undefined;
    houseNumber?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;
    geoLatitude?: number | undefined;
    geoLongitude?: number | undefined;

    constructor(data?: IAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.usage = _data["usage"];
            this.postalCode = _data["postalCode"];
            this.street = _data["street"];
            this.houseNumber = _data["houseNumber"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.country = _data["country"];
            this.geoLatitude = _data["geoLatitude"];
            this.geoLongitude = _data["geoLongitude"];
        }
    }

    static fromJS(data: any): Address {
        data = typeof data === 'object' ? data : {};
        let result = new Address();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["usage"] = this.usage;
        data["postalCode"] = this.postalCode;
        data["street"] = this.street;
        data["houseNumber"] = this.houseNumber;
        data["city"] = this.city;
        data["state"] = this.state;
        data["country"] = this.country;
        data["geoLatitude"] = this.geoLatitude;
        data["geoLongitude"] = this.geoLongitude;
        return data;
    }
}

export interface IAddress {
    type?: AddressType;
    usage?: AddressUsage;
    postalCode?: string | undefined;
    street?: string | undefined;
    houseNumber?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;
    geoLatitude?: number | undefined;
    geoLongitude?: number | undefined;
}

export enum AddressType {
    Business = "Business",
    Private = "Private",
}

export enum AddressUsage {
    Primary = "Primary",
    Delivery = "Delivery",
    Invoice = "Invoice"
}



export class Phone implements IPhone {
    phoneNo?: string | undefined;
    type?: PhoneNumberType;

    constructor(data?: IPhone) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phoneNo = _data["phoneNo"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): Phone {
        data = typeof data === 'object' ? data : {};
        let result = new Phone();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneNo"] = this.phoneNo;
        data["type"] = this.type;
        return data;
    }
}

export interface IPhone {
    phoneNo?: string | undefined;
    type?: PhoneNumberType;
}

export enum PhoneNumberType {
    Mobile = "Mobile",
    Business = "Business",
}

export class Emails implements IEmails {
    eMail1?: string | undefined;
    type?: EmailType;

    constructor(data?: IEmails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eMail1 = _data["eMail1"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): Emails {
        data = typeof data === 'object' ? data : {};
        let result = new Emails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eMail1"] = this.eMail1;
        data["type"] = this.type;
        return data;
    }
}

export interface IEmails {
    eMail1?: string | undefined;
    type?: EmailType;
}

export enum EmailType {
    Private = "Private",
    Business = "Business",
}

// export class ProformaApproval implements IProformaApproval {
//     approvalstatus?: Approvalstatus;

//     constructor(data?: IProformaApproval) {
//         if (data) {
//             for (var property in data) {
//                 if (data.hasOwnProperty(property))
//                     (<any>this)[property] = (<any>data)[property];
//             }
//         }
//     }

//     init(_data?: any) {
//         if (_data) {
//             this.approvalstatus = _data["approvalstatus"];
//         }
//     }

//     static fromJS(data: any): ProformaApproval {
//         data = typeof data === 'object' ? data : {};
//         let result = new ProformaApproval();
//         result.init(data);
//         return result;
//     }

//     toJSON(data?: any) {
//         data = typeof data === 'object' ? data : {};
//         data["approvalstatus"] = this.approvalstatus;
//         return data;
//     }
// }

// export interface IProformaApproval {
//     approvalstatus?: Approvalstatus;
// }

export enum Approvalstatus {
    NotProvided = "NotProvided",
    Accept = "Accept",
    Reject = "Reject"
}

export enum ApprovalStatusLowerCase {
    NotProvided = "notprovided",
    Accept = "accept",
    Reject = "reject"
}

export enum JobStatus {
    notok = "notok",
    ok = "ok",
    OK= "OK",
    NotOk = "NotOk"
}

export class ServiceLines implements IServiceLines {
    id?: string | undefined;
    description?: string | undefined;
    descriptionLong?: string | undefined;
    quantity?: number;
    price?: PriceWithDiscount;
    billToCustomerName?: string | undefined;
    jobId?: string | undefined;
    no? : string | undefined;
    type? : string | undefined;

    constructor(data?: IServiceLines) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.descriptionLong = _data["descriptionLong"];
            this.quantity = _data["quantity"];
            this.price = _data["price"] ? PriceWithDiscount.fromJS(_data["price"]) : <any>undefined;
            this.billToCustomerName = _data["billToCustomerName"];
            this.jobId = _data["jobId"];
            this.no = _data["no"];
            this.type = _data["type"];

        }
    }

    static fromJS(data: any): ServiceLines {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceLines();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["descriptionLong"] = this.descriptionLong;
        data["quantity"] = this.quantity;
        data["price"] = this.price ? this.price.toJSON() : <any>undefined;
        data["billToCustomerName"] = this.billToCustomerName;
        data["jobId"] = this.jobId;
        data["no"] = this.no;
        data["type"] = this.type;
        return data;
    }
}

export interface IServiceLines {
    id?: string | undefined;
    description?: string | undefined;
    descriptionLong?: string | undefined;
    quantity?: number;
    price?: PriceWithDiscount;
    billToCustomerName?: string | undefined;
}

export class PriceWithDiscount implements IPriceWithDiscount {
    grossPrice?: number | undefined;
    netPrice?: number | undefined;
    currency?: string | undefined;
    taxes?: Price_Taxes[] | undefined;
    discount?: Discount | undefined;
    constructor(data?: IPriceWithDiscount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.grossPrice = _data["grossPrice"];
            this.netPrice = _data["netPrice"];
            this.currency = _data["currency"];
            if (Array.isArray(_data["taxes"])) {
                this.taxes = [] as any;
                for (let item of _data["taxes"])
                    this.taxes!.push(Price_Taxes.fromJS(item));
            }
            this.discount = _data["discount"] ? Discount.fromJS(_data["discount"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PriceWithDiscount {
        data = typeof data === 'object' ? data : {};
        let result = new PriceWithDiscount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["grossPrice"] = this.grossPrice;
        data["netPrice"] = this.netPrice;
        data["currency"] = this.currency;
        if (Array.isArray(this.taxes)) {
            data["taxes"] = [];
            for (let item of this.taxes)
                data["taxes"].push(item.toJSON());
        }
        this.discount ? this.discount.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPriceWithDiscount {
    grossPrice?: number | undefined;
    netPrice?: number | undefined;
    currency?: string | undefined;
    taxes?: Price_Taxes[] | undefined;
    discount?: Discount | undefined;
}

export class Discount implements IDiscount {
    amount?: number;
    currency?: string | undefined;
    percent?: number;

    constructor(data?: IDiscount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.currency = _data["currency"];
            this.percent = _data["percent"];
        }
    }

    static fromJS(data: any): Discount {
        data = typeof data === 'object' ? data : {};
        let result = new Discount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["currency"] = this.currency;
        data["percent"] = this.percent;
        return data;
    }
}

export interface IDiscount {
    amount?: number;
    currency?: string | undefined;
    percent?: number;
}

export class FeatureFlag implements IFeatureFlag{
    id!: string;
    featureName?: string | undefined;
    value?: boolean | undefined;
    apiAdapterVersion?: string | undefined;

    constructor(data?: IFeatureFlag) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.featureName = _data["featureName"];
            this.value = _data["value"];
            this.apiAdapterVersion = _data["apiAdapterVersion"];
        }
    }

    static fromJS(data: any): FeatureFlag {
        data = typeof data === 'object' ? data : {};
        let result = new FeatureFlag();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["featureName"] = this.featureName;
        data["value"] = this.value;
        data["apiAdapterVersion"] = this.apiAdapterVersion;
        return data;
    }

}

export interface IFeatureFlag{
    id: string;
    featureName?: string | undefined;
    value?: boolean | undefined;
    apiAdapterVersion?: string | undefined;
}